module.exports = __webpack_public_path__ + "static/media/draft.08bfb224.svg";